module.exports = __webpack_public_path__ + "assets/0229d04a439a7c8b0764c14752f57c56.mp3";